import {
  CONSTITUENCY_LIST_FETCH_DATA_SUCCESS,
  CONSTITUENCY_LIST_HAVE_ERROR,
  CONSTITUENCY_LIST_ARE_LOADING,
} from "../actionType";
import HttpService from "../../utils/httpService";
import { Get } from "../../services/api.service";

// Action creator function to handle different types of home primary actionsw
export function constituenciesAction(action, payload) {
  switch (action) {
    case CONSTITUENCY_LIST_HAVE_ERROR:
      return {
        type: action,
        hasError: payload,
      };

    case CONSTITUENCY_LIST_ARE_LOADING:
      return {
        type: action,
        isLoading: payload,
      };

    case CONSTITUENCY_LIST_FETCH_DATA_SUCCESS:
      return {
        type: action,
        homePrimary: payload,
      };

    default:
      return;
  }
}

// Async action creator function to fetch home primary data
export function constituenciesFetchData(id, city_id, ele_id) {
  return (dispatch) => {
    try {
      // Dispatch action indicating data is loading
      dispatch(constituenciesAction(CONSTITUENCY_LIST_ARE_LOADING, true));

      // Fetch home primary data using GET request
      return new Promise((resolve, reject) => {
        Get(HttpService.constituencies + `?state_id=${id}&city_id=${city_id}&election_id=${ele_id}`).then(
          (result) => {
            // Dispatch action with fetched home primary data
            dispatch(constituenciesAction(CONSTITUENCY_LIST_FETCH_DATA_SUCCESS, result));
            resolve(result);
          },
          (error) => {
            reject(error); // Reject promise with error if fetching fails
          },
        );
      });
    } catch (error) {
      // Dispatch action if there's an error in fetching data
      dispatch(constituenciesAction(CONSTITUENCY_LIST_HAVE_ERROR, true));
    }
  };
}
